import comp from "./TaggedPracticesV2";
export default comp;
